module.exports = __webpack_public_path__ + "static/media/filter-gender-men.a914b64b.svg";